import { IProgressHandler } from "../abstraction/IProgressHandler";

export const services: {
    progress?: IProgressHandler
} = {}